import React, { Component } from 'react';
import PropsType from 'prop-types';

import "./ZCMsg.css";

class ZCMSysMsg extends Component {

  static propTypes = {
    text: PropsType.string,
  }

  static defaultProps = {
    text: "",
  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this.setState((state, props) => ({ 
      ...props
    }));
  }

  static getDerivedStateFromProps(nextProps, prevStat){
    if(prevStat !== nextProps){
      return {
        ...nextProps
      }
    }
  }

  render(){
    let { cssPrefix, text } = this.state;
    return (
      <div className={cssPrefix + " zchat-sysmsg"}>
        {text}
      </div>
    )
  }
}

export default ZCMSysMsg;